@import "@/scss/use-bootstrap-mixins";

.wizard {
  display: flex !important;
  gap: 6px !important;
  // flex-direction: column;
  flex-wrap: wrap !important;
  margin-bottom: 12px !important;
}

.tags {
  display: none;
  @include media-breakpoint-up(lg) {
    display: flex;
    gap: 6px;
    // flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  div {
    border: 1px solid;
    width: fit-content;
    border-radius: 20px;
    display: flex;
    height: 30px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    font-size: 12px !important;
    font-weight: 600;
    padding: 0 12px;
  }

  span {
    margin: 0 !important;
    font-size: 12px !important;
    font-weight: 600 !important;
  }

  svg {
    height: 1em !important;
  }
}

.primary {
  div {
    border-color: #5e5e5e !important;
    color: #5e5e5e !important;
    background-color: transparent;
  }
}

.secondary {
  div {
    border-color: var(--rs-theme-lightest) !important;
    color: var(--rs-theme-darkest) !important;
    background-color: var(--rs-theme-lightest) !important;
    span {
      color: var(--rs-theme-darkest) !important;
    }
  }
}

.tertiary {
  div {
    border-color: var(--rs-theme) !important;
    color: #fff !important;
    background-color: var(--rs-theme) !important;
    span {
      color: #fff !important;
    }
  }
}
